import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { OfferDetail, OfferStatusChange } from 'types/api'
import { BaseParams } from 'types/utils'

// Hand-extended until the OpenAPI types are regenerated: unpaid rents of the
// offer to delete when terminating.
type OfferStatusChangeBody = OfferStatusChange & { delete_rent_ids?: string[] }

export function useChangeStatus() {
  const queryClient = useQueryClient()
  const toast = useToast()
  const { t } = useTranslation('toast')
  const onError = useOnError()

  async function changeStatus({
    id,
    body
  }: BaseParams<[OfferStatusChangeBody, OfferDetail], 'POST'>) {
    const res = await apiClient.post<OfferDetail>(
      SNA_PREFIX + `offers/${id}/operations/change-status/`,
      body
    )
    return res.data
  }

  return useMutation({
    mutationFn: changeStatus,
    onSuccess: (data, variables) => {
      variables?.params?.onSuccess?.(data)
      toast.success({ message: t('offerCreated') })
      queryClient.invalidateQueries({ queryKey: ['offers'] })
      queryClient.invalidateQueries({ queryKey: ['offers-detail'] })
      queryClient.invalidateQueries({ queryKey: ['rents'] })
      queryClient.invalidateQueries({ queryKey: ['contracts'] })
    },
    onError
  })
}
